export default function script_heroAnimation() {
  $(window).on('load', function(){     //ページ内のすべての要素が読み込まれた後に動作を行う
    setTimeout(function(){  //すべての要素が読み込まれた後0.5秒後にスタート
      $(".Load").fadeOut("slow");  //ロード幕のフェードアウト
  
      const firstviewWrap = $('#firstviewWrap'),     //firstviewWrap要素を変数に入れる
            firstviewBack = $('#firstviewBack'),     //firstviewBack要素を変数に入れる
            firstviewBackImg = firstviewBack.children('img'),     //firstviewBack要素の子のimg要素を変数に入れる
            titleRight = $('.Hero__title'),     //titleLeft要素を変数に入れる
            titleLeft = $('.Hero__logo'),     //titleRight要素を変数に入れる
            titleLeftBack = $('.Hero__sub'),   //titleRightの背景要素を変数に入れる
            titleArrow = $('.Hero__arrow'),   //titleArrowの要素を変数に入れる
            fadeSpeed = 1000,     //フェードスピード
            switchDelay = 3800,     //切り替える時間
            switchPoint = 601,
            imgRatio = firstviewBackImg.width() / firstviewBackImg.height();     //縦横比
  
      function firstviewFit(){
        var wdWidth = window.innerWidth,     //ウィンドウの横幅を取得
            wdHeight = window.innerHeight,     //ウィンドウの高さを取得
            heroHeight = wdHeight - 70,     //ウィンドウの高さからヘッダーの高さを引く
            setHeight = wdWidth / imgRatio,
            scrollTop = $(window).scrollTop();  //ブラウザのスクロール位置を取得

        if(scrollTop === 0) {  //ブラウザのスクロール位置が0の時だけリサイズ処理を行う
          if(setHeight < heroHeight){
            setHeight = window.innerHeight - 70;
            wdWidth = setHeight * imgRatio;
          }
          firstviewWrap.css({height: wdHeight-70});     //ウィンドウの高さをfirstviewWrap要素に設定
          firstviewBackImg.css({marginTop: Math.round(-setHeight/2), marginLeft: Math.round(-wdWidth/2), width: wdWidth, height: setHeight});     //画像の位置設定
        }
      }
  
      //リサイズされた時に、firstviewFit関数実行とロゴを中央に配置
      jQuery(window).on('resize', function(){
        firstviewFit();
        titleRight.css({opacity:'0'});  //「PLASTIC INJECTION MOLDING」を消す
        titleArrow.css({opacity:'0'});  //矢印を消す
        titleLeftBack.stop().css({backgroundColor: 'rgba(0,0,0,0)', width: '100%', height: '100%'});  //ロゴ背景を消し、全面に配置
        titleLeft.stop().css({top: '50%', left: '50%'});  //ロゴを中央配置
      });

      $(window).scrollTop(0);  //ページロード（更新）時にブラウザのスクロール位置を0にする
      firstviewFit();     //ページロード時に一度firstviewFit関数実行
  
  
  
      //アニメーションの順番を設定
      if(window.innerWidth < switchPoint) {   //モバイルの場合
        function playAnimation(){
          animation05()
          .then(animation06)
          .then(animation07)
          .then(animation08);
        }
        //アニメーション実行
        playAnimation();
      } else {   //pcの場合
        function playAnimation(){
          animation01()
          .then(animation02)
          .then(animation03)
          .then(animation04);
        }
        //アニメーション実行
        playAnimation();
      }
  
      //各アニメーションの設定
      //pc,tb用
      function animation01() {  //Hero__sub（左側部分）が、width100%（初期位置・全画面いっぱい）から左にwidth35%まで縮む
        var deferred = new $.Deferred;
        titleLeftBack.delay(1000).animate({width: '35%'}, {duration: 1000, easing: 'easeOutElastic', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      function animation02() {  //Hero__arrow（矢印）が出現する（left30%（初期位置）から右にleft35%まで移動）
        var deferred = new $.Deferred;
        titleArrow.css({visibility:'visible', opacity:'0'}).stop().animate({opacity: '1', left: '35%'}, {duration: 300, easing: 'easeInOutCubic', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      function animation03() {  //Hero__title（右側部分）が出現する（left20%（初期位置）から右にleft50%まで移動）
        var deferred = new $.Deferred;
        titleRight.css({visibility:'visible', opacity:'0'}).stop().animate({opacity: '1', left: '50%'}, {duration: 500, easing: 'easeInOutCubic', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      function animation04() {  //Hero__logoを白色から青色のものに付け替えると同時に、Hero__sub（左側部分）を黒背景に変える
        var deferred = new $.Deferred;
        titleLeft.css({opacity: '0'}).attr('src', './dist/images/common/logo_bluewhite_004.svg').animate({opacity: '1'},{duration: 1000, easing: 'easeOutQuad'}),
        titleLeftBack.animate({backgroundColor: 'rgba(0,0,0,0.7)'}, {duration: 1000, easing: 'easeOutQuad', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      //sp用
      function animation05() {  //Hero__sub（上側部分）が、height100%（初期位置・全画面いっぱい）から上にheight35%まで縮む
        var deferred = new $.Deferred;
        titleLeftBack.delay(1000).animate({height: '35%'}, {duration: 1000, easing: 'easeOutElastic', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      function animation06() {  //Hero__arrow（矢印）が出現する（top30%（初期位置）から下にtop35%まで移動）
        var deferred = new $.Deferred;
        titleArrow.css({visibility:'visible', opacity:'0'}).stop().animate({opacity: '1', top: '35%'}, {duration: 300, easing: 'easeInOutCubic', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      function animation07() {  //Hero__title（下側部分）が出現する（top30%（初期位置）から下にleft55%まで移動）
        var deferred = new $.Deferred;
        titleRight.css({visibility:'visible', opacity:'0'}).stop().animate({opacity: '1', top: '55%'}, {duration: 500, easing: 'easeInOutCubic', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      function animation08() {  //Hero__logoを白色から青色のものに付け替えると同時に、Hero__sub（左側部分）を黒背景に変える
        var deferred = new $.Deferred;
        titleLeft.css({opacity: '0'}).attr('src', './dist/images/common/logo_bluewhite_004.svg').animate({opacity: '1'},{duration: 1000, easing: 'easeOutQuad'}),
        titleLeftBack.animate({backgroundColor: 'rgba(0,0,0,0)'}, {duration: 1000, easing: 'easeOutQuad', complete: function(){deferred.resolve();}});
        return deferred.promise();
      }
  
      //背景スライド
      firstviewBackImg.css({visibility: 'visible', opacity: '0'}).first().stop().animate({opacity: '1'}, fadeSpeed);     //最初の画像を表示
  
      setInterval(function(){
        var firstviewBackImgFirst = firstviewBack.find('img:first');     //最初の画像を変数に入れる
  
        firstviewBackImgFirst.stop().animate({opacity: '0'}, fadeSpeed).next().stop().animate({opacity: '1'}, fadeSpeed).end().appendTo(firstviewBack);     //次の画像を表示し、一つ前の画像を最後に移動
      }, switchDelay);
    }, 500);
  });
}
